import { Box, Image } from "@chakra-ui/react";
import { useI18n } from "@/hooks/useI18n";
import PageWrap from "@/components/PageWrap";
import { useMedia } from "@/hooks/useMedia";
import { Flex, Text } from "@chakra-ui/react";
import BackBtn from "../components/BackBtn";
import { PageContainer } from "../styles";
import { useEffect, useState, useRef, useMemo } from "react";
import BXNSelect from "@/components/ui/WSelect";
import { BXButton, BXInput } from "@/styles";
import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  getSubAccountListApi,
  transferAccountBalanceApi,
  getSubAccountBalanceApi,
} from "@/api/subAccount";
import { getCurrencyListApi } from "@/api/common";
import { useAppSelector } from "@/state/hooks";
import { jsUuid } from "@/helpers/func/stringPro";
import { toastTip } from "@/components/ui/toast";
import { throttle } from "lodash";
import { useSearchParams } from "react-router-dom";

const AccountTransfer = () => {
  const { t } = useI18n();
  const { isMobile } = useMedia();
  const [inputBalance, setInputBalance] = useState("");
  const selectRef = useRef(null);
  const [accountListData, setSubAccountListData] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [fromAccount, setFromAccount] = useState();
  const [toAccount, setToAccount] = useState();
  const [showCurrencyMenu, setShowCurrencyMenu] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState();
  const [isFocus, setIsFocus] = useState(false);
  const [accountBalance, setAccountBalance] = useState({});
  const [reverse, setReverse] = useState(false);
  const { email, target_id } = useAppSelector((state) => state.user.userInfo);
  const [searchParams] = useSearchParams();
  const toAccountId = searchParams.get("accountId");

  const getSubAccountListFunc = async () => {
    const res = await getSubAccountListApi();
    if (res.code === 0) {
      const list = res.data.sub_users
        .filter((d) => d.status === "NORMAL")
        .map((d) => {
          return {
            ...d,
            label: d.email,
            value: d.target_id,
          };
        });
      setToAccount(list.filter((d) => d.uid === toAccountId)[0] || list[0]);
      setSubAccountListData(list);
    }
  };

  const getCurrencyList = async () => {
    const res = await getCurrencyListApi({ scene: "account_transfer" });
    if (res.code === 0) {
      setCurrencyList(res.data.currency_list);
      setSelectedCurrency(res.data.currency_list[0]);
    }
  };

  const getSubAccountBalance = async () => {
    const params = {
      from_account_target_id:
        fromAccount?.email === email ? target_id : fromAccount?.target_id,
      to_account_target_id: toAccount?.target_id,
      currency: selectedCurrency.name,
    };
    const res = await getSubAccountBalanceApi(params);
    if (res.code === 0) {
      setAccountBalance(res.data);
    }
  };

  const handleTransfer = throttle(async () => {
    const res = await transferAccountBalanceApi({
      from_account_target_id: fromAccount?.target_id,
      to_account_target_id: toAccount?.target_id,
      amount: inputBalance,
      currency: selectedCurrency?.name,
      request_id: jsUuid(),
    });
    console.log("[[res]]", res);
    if (res?.code === 0 && res?.data?.request_id) {
      toastTip(t("fNFAnFLpEoAIoPfbh"), { type: "success" });
      getSubAccountBalance();
      setInputBalance("");
    } else {
    }
  }, 3000);

  useEffect(() => {
    getCurrencyList();
    getSubAccountListFunc();
  }, []);

  // const allAccountList = useMemo(() => {
  //   if (accountListData?.length > 0 && email && target_id) {
  //     const list = [
  //       {
  //         label: email,
  //         value: email,
  //         target_id: target_id,
  //       },
  //       ...accountListData,
  //     ];
  //     return list;
  //   }
  // }, [accountListData, email, target_id]);

  // const memoAccountListSelects = useMemo(() => {
  //   if (allAccountList?.length > 0 && fromAccount?.target_id) {
  //     const list = allAccountList.filter(
  //       (d) => d.target_id !== fromAccount?.target_id
  //     );
  //     return list;
  //   }
  // }, [allAccountList, fromAccount]);

  useEffect(() => {
    if (
      fromAccount?.target_id &&
      toAccount?.target_id &&
      selectedCurrency?.name
    ) {
      getSubAccountBalance();
    }
  }, [fromAccount, toAccount, selectedCurrency]);

  useEffect(() => {
    if (email) {
      setFromAccount({
        label: email,
        value: email,
        target_id: target_id,
      });
    }
  }, [email, target_id]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setShowCurrencyMenu(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const canSubmit = useMemo(() => {
    if (
      !inputBalance ||
      !accountBalance?.from_account_amount ||
      !selectedCurrency ||
      +inputBalance <= 0
    )
      return false;

    if (inputBalance) {
      if (+inputBalance > +accountBalance?.from_account_amount) {
        return false;
      }
    }
    return true;
  }, [inputBalance, accountBalance]);

  const handleOnBlur = () => {
    setIsFocus(false);
  };

  const handleInputValue = (e) => {
    let value = e.target.value;
    value = value?.trim();

    if (value >= 0) {
      const index = value.indexOf(".");
      if (index > 0) {
        let prev = value.slice(0, index);
        let suffix = value.slice(index + 1);
        if (String(suffix)?.length >= selectedCurrency?.digits) {
          suffix = suffix.slice(0, selectedCurrency.digits);
          value = prev + "." + suffix;
        }
      }
      setInputBalance(value);
    } else {
      setInputBalance("");
    }
  };

  const handleChangeCurrency = (item) => {
    setSelectedCurrency(item);
    setShowCurrencyMenu(false);
  };

  const switchAccount = () => {
    setReverse(!reverse);
    const old_from = fromAccount;
    const old_to = toAccount;
    setFromAccount(old_to);
    setToAccount(old_from);
  };

  const setMaxValue = () => {
    if (accountBalance?.from_account_amount) {
      setInputBalance(accountBalance?.from_account_amount);
    }
  };

  return (
    <PageWrap>
      <PageContainer pt={!isMobile ? "30px" : "0"}>
        <Box w={["100%", "1200px"]} margin={"0 auto"}>
          <Flex
            justifyContent={"space-between"}
            alignItems={"center"}
            flexDirection={isMobile ? "column" : "row"}
            padding={"0 20px"}
          >
            {!isMobile ? (
              <>
                <BackBtn path={"/trade/subAccount"} />
              </>
            ) : (
              <>
                <Flex w={"100%"} justifyContent={"space-between"}>
                  <BackBtn path={"/trade/subAccount"} />
                </Flex>
              </>
            )}
          </Flex>

          <Flex
            mt={["30px", "55px"]}
            w={["90%", "500px"]}
            margin={"0 auto"}
            paddingBottom={"40px"}
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Text fontSize={32} fontWeight={600}>
              {t("KgtuAymJbpqjZHQACDKA")}
            </Text>
            <Flex
              w={"100%"}
              mt={"20px"}
              bgColor={"rgba(32, 26, 85, 0.05)"}
              padding={"10px"}
              borderRadius={"12px"}
              alignItems={"center"}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
              >
                <path
                  d="M12.0008 4.37683C7.40915 4.37683 3.66748 8.1185 3.66748 12.7102C3.66748 17.3018 7.40915 21.0435 12.0008 21.0435C16.5925 21.0435 20.3341 17.3018 20.3341 12.7102C20.3341 8.1185 16.5925 4.37683 12.0008 4.37683ZM11.3758 9.37683C11.3758 9.03516 11.6591 8.75183 12.0008 8.75183C12.3425 8.75183 12.6258 9.03516 12.6258 9.37683V13.5435C12.6258 13.8852 12.3425 14.1685 12.0008 14.1685C11.6591 14.1685 11.3758 13.8852 11.3758 13.5435V9.37683ZM12.7675 16.3602C12.7258 16.4685 12.6675 16.5518 12.5925 16.6352C12.5091 16.7102 12.4175 16.7685 12.3175 16.8102C12.2175 16.8518 12.1091 16.8768 12.0008 16.8768C11.8925 16.8768 11.7841 16.8518 11.6841 16.8102C11.5841 16.7685 11.4925 16.7102 11.4091 16.6352C11.3341 16.5518 11.2758 16.4685 11.2341 16.3602C11.1925 16.2602 11.1675 16.1518 11.1675 16.0435C11.1675 15.9352 11.1925 15.8268 11.2341 15.7268C11.2758 15.6268 11.3341 15.5352 11.4091 15.4518C11.4925 15.3768 11.5841 15.3185 11.6841 15.2768C11.8841 15.1935 12.1175 15.1935 12.3175 15.2768C12.4175 15.3185 12.5091 15.3768 12.5925 15.4518C12.6675 15.5352 12.7258 15.6268 12.7675 15.7268C12.8091 15.8268 12.8341 15.9352 12.8341 16.0435C12.8341 16.1518 12.8091 16.2602 12.7675 16.3602Z"
                  fill="#010313"
                />
              </svg>
              <Text fontSize={12}>{t("WriODPyMHmFqbNRIkh")}</Text>
            </Flex>
            {/* 账号 */}
            <Flex
              flexDirection={!isMobile ? "" : "column"}
              alignItems={"center"}
              justifyContent={"space-between"}
              // flexFlow={reverse ? "row-reverse" : ""}
              w={"100%"}
              mt={"40px"}
            >
              {/* <Box
                border={"1px solid #E3E4F1"}
                padding={"10px 20px"}
                borderRadius={"12px"}
                height={"47px"}
                fontSize={"14px"}
                w={!isMobile ? "45%" : "100%"}
              >
                from_
                {fromAccount?.label}
              </Box> */}
              <BXNSelect
                style={{ width: !isMobile ? "45%" : "100%", fontSize: "14px" }}
                options={reverse ? accountListData : [fromAccount]}
                defaultOpt={fromAccount}
                needArrowIcon={reverse ? true : false}
                handleSelect={(item) => {
                  setFromAccount(item);
                }}
              ></BXNSelect>
              <Image
                padding={!isMobile ? "0px" : "10px"}
                src="../../wwwsite/images/transfer/exchange.svg"
                cursor={"pointer"}
                onClick={switchAccount}
              />
              <BXNSelect
                style={{ width: !isMobile ? "45%" : "100%", fontSize: "14px" }}
                // options={accountListData}
                options={!reverse ? accountListData : [toAccount]}
                needArrowIcon={!reverse ? true : false}
                defaultOpt={toAccount}
                handleSelect={(item) => {
                  setToAccount(item);
                }}
              ></BXNSelect>
            </Flex>
            {/* 可用资产 */}
            <Flex
              alignItems={!isMobile ? "space-between" : "flex-start"}
              flexDirection={!isMobile ? "" : "column"}
              justifyContent={!isMobile ? "space-between" : "flex-start"}
              w={"100%"}
              mt={!isMobile ? "10px" : "20px"}
            >
              <Flex w={"40%"} fontSize={"14px"}>
                <Text color={"#7B7C8F"}>{t("HYTGqldMNoESWJswz")}: &nbsp;</Text>
                <Text color={"#010313"} fontWeight={"bold"}>
                  {accountBalance?.from_account_amount || "-"}
                  {` ${selectedCurrency?.name || "-"}`}
                </Text>
              </Flex>

              <Flex
                w={"40%"}
                fontSize={"14px"}
                justifyContent={!isMobile ? "flex-end" : ""}
              >
                <Text color={"#7B7C8F"}>{t("HYTGqldMNoESWJswz")}: &nbsp;</Text>
                <Text color={"#010313"} fontWeight={"bold"}>
                  {accountBalance?.to_account_amount || "-"}
                  {` ${selectedCurrency?.name || "-"}`}
                </Text>
              </Flex>
            </Flex>
            <Box
              mt="40px"
              w={"100%"}
              lineHeight={"60px"}
              border={isFocus ? "1px solid #4A3DE6" : "1px solid #e2e8f0"}
              borderRadius={"12px"}
            >
              <Flex alignItems={"center"}>
                <Box
                  border="none"
                  position="relative"
                  fontSize={"14px"}
                  h={"60px"}
                >
                  <Box pl="20px" mr="20px">
                    <Flex
                      cursor="pointer"
                      alignItems={"center"}
                      ref={selectRef}
                      onClick={() => setShowCurrencyMenu(true)}
                    >
                      {selectedCurrency && (
                        <>
                          <Image
                            src={selectedCurrency?.icon}
                            mr="5px"
                            w="20px"
                          />
                          {` ${selectedCurrency?.name}`}
                          <ChevronDownIcon />
                        </>
                      )}
                    </Flex>
                  </Box>
                  {showCurrencyMenu && (
                    <Box
                      padding="10px 5px"
                      bg="#fff"
                      borderRadius={"12px"}
                      position="absolute"
                      zIndex="1"
                    >
                      {currencyList &&
                        currencyList.length > 0 &&
                        currencyList.map((item, idx) => {
                          return (
                            <Flex
                              value={item?.name}
                              key={idx}
                              cursor="pointer"
                              fontSize={"14px"}
                              h="40px"
                              padding="10px"
                              width={"max-content"}
                              alignItems={"center"}
                              mb="10px"
                              borderRadius={"10px"}
                              _hover={{
                                bg: "rgba(32, 26, 85, 0.05)",
                              }}
                              onClick={() => {
                                handleChangeCurrency(item);
                              }}
                            >
                              <Image src={item?.icon} mr="5px" w="20px" />
                              {item?.name || ""}
                            </Flex>
                          );
                        })}
                    </Box>
                  )}
                </Box>
                <Box color="#dfe0ee" fontWeight={"normal"}>
                  |
                </Box>
                <BXInput
                  w={["40%", "280px"]}
                  h={"40px"}
                  textAlign={"right"}
                  fontWeight={"bold"}
                  fontSize={"16px"}
                  border="0"
                  placeholder="0"
                  _focusVisible={{ boxShadow: "none" }}
                  value={inputBalance}
                  onChange={handleInputValue}
                  onBlur={handleOnBlur}
                  marginTop={"0px"}
                  onFocus={() => setIsFocus(true)}
                />
                <Text ml="10px" mr="20px" w={["15%", "auto"]}>
                  {` ${selectedCurrency?.name || "-"}`}
                </Text>
                <Text
                  color="#333BF5"
                  cursor={"pointer"}
                  w={["15%"]}
                  onClick={() => setMaxValue()}
                >
                  {t("SywvArMjCuuGzTEtlJ")}
                </Text>
              </Flex>
            </Box>
            <BXButton
              w="350px"
              mt="40px"
              onClick={() => {
                if (canSubmit) {
                  handleTransfer();
                }
              }}
              className={!canSubmit ? "disabled" : ""}
            >
              {t("AQrCocFqoKoYieUnT")}
            </BXButton>
          </Flex>
        </Box>
      </PageContainer>
    </PageWrap>
  );
};

export default AccountTransfer;
